<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="transportAddEditForm">
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group required">
            <label
              *ngIf="
                transportAddEditForm.get('transport')?.value ||
                transportAddEditForm.get('region')?.value ||
                transportAddEditForm.get('organizationName')?.value
              "
              class="sub-header-drpdown pb-2"
              >Transport</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #transport
              [items]="transportList"
              [searchable]="false"
              bindValue="id"
              bindLabel="name"
              formControlName="transport"
              [readonly]="isDisabledDropDown"
              [searchFn]="commonInputSearch"
              placeholder="Transport mode *"
              (change)="onChange($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    placeholder="Search..."
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="transport.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="submitted || transportAddEditForm.controls['transport']?.touched"
              class="input-error"
            >
              <div *ngIf="transportAddEditForm.controls['transport']?.invalid">
                The transport mode is required.
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group required">
            <label
              *ngIf="
                transportAddEditForm.get('transport')?.value ||
                transportAddEditForm.get('region')?.value ||
                transportAddEditForm.get('organizationName')?.value
              "
              class="sub-header-drpdown pb-2"
              >Region</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #region
              [items]="regionData"
              [searchable]="false"
              bindLabel="name"
              formControlName="region"
              [readonly]="isDisabledDropDown"
              [searchFn]="commonInputSearch"
              placeholder="Region *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    placeholder="Search..."
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="region.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (transportAddEditForm.controls['region']?.touched &&
                  transportAddEditForm.controls['region']?.invalid) ||
                transportAddEditForm.controls['region'].value?.name === '--Select Region-- ' ||
                (submitted && !transportAddEditForm.controls['region'].value?.name)
              "
              class="input-error"
            >
              Region is required.
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group required">
            <label
              *ngIf="transportAddEditForm.get('organizationName')?.value"
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <label
              *ngIf="
                !transportAddEditForm.get('organizationName')?.value &&
                (transportAddEditForm.get('transport')?.value ||
                  transportAddEditForm.get('region')?.value)
              "
              class="placeholder-sub-header pb-2"
              >Holder_text</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #organization
              [items]="organizationlist"
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="commonInputSearch"
              placeholder="All organization"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    placeholder="Search..."
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="organization.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="tranportForm">
      <div class="row">
        <div class="col-sm-4" *ngFor="let formData of indicatorList">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input
                [formControlName]="formData.name"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="{{ formData.name }} {{ formData.unit }}"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>{{ formData.name }} ( {{ formData.unit }})</label>
              <div *ngIf="submitted && tranportForm.get(formData.name)?.invalid">
                <div class="input-error">Default value is required</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="setButtonAndError text-margin">
        <div class="modal-footer">
          <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
          <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">
            Save
          </button>
        </div>

        <div
          class="redErrorTag"
          *ngIf="submitted && (this.transportAddEditForm.invalid || tranportForm.invalid)"
        >
          <div class="bigScreenErrContain">
            <div>
              <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
            </div>
            <div>
              <div class="mb-3">
                <span>To proceed please complete the following fields : </span>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (transportAddEditForm.controls['transport']?.touched || submitted) &&
                    transportAddEditForm.controls['transport']?.invalid
                  "
                >
                  Transport
                </div>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (transportAddEditForm.controls['region']?.touched &&
                      transportAddEditForm.controls['region']?.invalid) ||
                    transportAddEditForm.controls['region'].value?.name === '--Select region-- ' ||
                    (submitted && !transportAddEditForm.controls['region'].value?.name)
                  "
                >
                  Region
                </div>
              </div>
              <div class="topBottomCss" *ngIf="tranportForm.invalid">
                <div>Default value</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
